var _path, _path2, _rect, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLeaveicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.74984 2.5C7.74984 2.08579 7.41405 1.75 6.99984 1.75C6.58563 1.75 6.24984 2.08579 6.24984 2.5V4.07926C4.81051 4.19451 3.86561 4.47737 3.17141 5.17157C2.47721 5.86577 2.19435 6.81067 2.0791 8.25H21.9205C21.8053 6.81067 21.5224 5.86577 20.8282 5.17157C20.134 4.47737 19.1891 4.19451 17.7498 4.07926V2.5C17.7498 2.08579 17.414 1.75 16.9998 1.75C16.5856 1.75 16.2498 2.08579 16.2498 2.5V4.0129C15.5845 4 14.8388 4 13.9998 4H9.99984C9.16081 4 8.41511 4 7.74984 4.0129V2.5Z",
    fill: "#384573"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22 11.9961V13.9961C22 17.7673 22 19.653 20.8284 20.8245C19.6569 21.9961 17.7712 21.9961 14 21.9961H10C6.22876 21.9961 4.34315 21.9961 3.17157 20.8245C2 19.653 2 17.7673 2 13.9961V11.9961C2 11.1571 2 10.4114 2.0129 9.74609H21.9871C22 10.4114 22 11.1571 22 11.9961ZM16 13.2461C16.4142 13.2461 16.75 13.5819 16.75 13.9961V15.2461H18C18.4142 15.2461 18.75 15.5819 18.75 15.9961C18.75 16.4103 18.4142 16.7461 18 16.7461H16.75V17.9961C16.75 18.4103 16.4142 18.7461 16 18.7461C15.5858 18.7461 15.25 18.4103 15.25 17.9961V16.7461H14C13.5858 16.7461 13.25 16.4103 13.25 15.9961C13.25 15.5819 13.5858 15.2461 14 15.2461H15.25V13.9961C15.25 13.5819 15.5858 13.2461 16 13.2461Z",
    fill: "#384573"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 13,
    width: 7,
    height: 7,
    fill: "#384573"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9 16L15 16",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeaveicon);
export default __webpack_public_path__ + "static/media/leaveicon.9436c3963e8f5dc4665a11912fede730.svg";
export { ForwardRef as ReactComponent };